<template>
  <div>
    <!--    driver name-->
    <v-row
      style="border-bottom: 1px solid #E5E7EB;"
      class="margin-0"
    >
      <v-col
        class="d-flex justify-start driver-label"
      >
        <div
          class="driver-label--wrapper"
        >
          {{ vehicleLabel }}
        </div>
      </v-col>

      <v-col
        class="d-flex justify-end"
      >
        <table-row-actions-menu
          :data-index="itemIndex"
          :config="actionsConfig"
          :table-data="data"
        />
      </v-col>
    </v-row>

    <!--    visible data section-->
    <v-row
      v-for="(dataObject, dataObjIndex) in getAllItemDetails()"
      :key="dataObjIndex"
      class="margin-0"
    >
      <v-col
        class="data-label"
      >
        {{ dataObject.label }}
      </v-col>

      <v-col
        class="d-flex justify-end data-value"
      >
        {{ dataObject.value }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TableRowActionsMenu from '@/global/components/table/components/TableRowActionsMenu.vue'
import { isFunction } from '@/global/utils/utils'
import { dateService, FORMATS } from '@/global/services/date'
import { showDetailsAction, deleteAction } from '@/global/components/table/helpers/tableActions'

export default {
  name: 'ViolationsGridBlock',

  components: {
    TableRowActionsMenu
  },

  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    itemIndex: {
      type: Number,
      default: 0
    },
    blockConfig: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      informationDialogConfig: {
        openDialog: false,
        message: this.$t('people/person.confirm_delete'),
        title: '',
        positiveBtnText: '',
        negativeBtnText: this.$t('base.cancel'),
        callbackFn: () => {}
      }
    }
  },

  computed: {
    vehicleLabel () {
      return `${this.item?.vehicle?.registration || ''} (${this.item?.vehicle?.label || ''})`
    },

    actionsConfig () {
      return {
        tableConfig: {
          actionsConfig: [
            showDetailsAction(this.$t, (event) => this.showEdit(event)),
            deleteAction(this.$t, (event) => this.onDelete(event))
          ]
        }
      }
    }
  },

  methods: {
    getAllItemDetails () {
      return [
        {
          label: this.$t('people/violations.violation_date'),
          value: this.item?.date ? dateService.formatCustom(this.item.date, FORMATS.isoDatetime, FORMATS.date) : '-'
        },
        {
          label: this.$t('people/violations.violation_type'),
          value: `${this.item?.type?.description || ''}`
        },
        {
          label: this.$t('people/violations.comment'),
          value: this.item?.note || '--'
        }
      ]
    },

    showEdit (event) {
      const { onEdit } = this.blockConfig || {}
      if (isFunction(onEdit)) {
        onEdit(event)
      }
    },

    onDelete (event) {
      const { onDelete } = this.blockConfig || {}
      if (isFunction(onDelete)) {
        onDelete(event)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.driver-label {
  display: flex;
  justify-content: flex-start;
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #111827;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}

.driver-label--wrapper {
  display: flex;
  height: 48px;
  align-items: center;
}

.data-label {
  font-family: 'Satoshi', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #6B7280;
}

.data-value {
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #111827;
  text-align: right;
}

.arrowUpDown {
  position: absolute;
  bottom: 10px;
  left: 50%;
}

.arrowUpDown:hover {
  cursor: pointer;
}
</style>
